import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function BackToHome() {
  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 pt-4 pb-10 flex justify-center">
      <Link
        to="/"
        data-testid="back-to-home"
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-white/[0.04] hover:bg-white/[0.08] border border-white/10 text-zinc-300 hover:text-white text-sm font-semibold transition-colors"
      >
        <ArrowLeft className="w-4 h-4" /> Terug naar home
      </Link>
    </div>
  );
}
